import React from 'react';

export default function (props) {
  return (
    <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={props.style}>
      <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
    </svg>
  );
}
